<script setup>
import { onMounted, onUnmounted, ref, reactive } from 'vue';
import gsap from 'gsap-trial';
import DownloadBtn from '@/components/DownloadBtn.vue'
import ProjectCar from '@/components/ProjectCar.vue'
import Contact from '@/components/Contact.vue'
import MailAddress from '@/components/MailAddress.vue'
import Email from '@/components/Email.vue'
import { ScrollTrigger } from 'gsap-trial/ScrollTrigger';
import textJSON from '@/assets/json/text.json'
import Request from '@/core/request'
import { ElNotification } from 'element-plus'

gsap.registerPlugin(ScrollTrigger);
const main = ref();
const scrollContainer = ref(null);
const clientHeight = ref(0)
const scrollTop = ref(0)
const scrollHeight = ref(0)
const videoRef = ref()
const videoClientHeight = ref(0)
const topRef = ref()
const loading = ref(false)
const formData = reactive({
    email: '',
    name: '',
    subject: '',
    contact: '',
    message: ''
})
const errorMessage = reactive({
    name: 'Please enter name',
    email: 'Please enter email',
    subject: '',
    contact: 'Please enter contact',
    message: ''
})
let ctx;
const onVideoLoaded = (e) => {
    videoClientHeight.value = videoRef.value.clientHeight
}

const onContactUs = () => {
    if (loading.value) return
    for (const key in formData) {
        if (!formData[key] && errorMessage[key]) {
            ElNotification({
                title: 'Warning',
                message: errorMessage[key],
                type: 'warning',
            })
            return
        }
    }
    loading.value = true
    Request.get(`/api/system/contactUs?email=${formData.email}&name=${formData.name}&subject=${formData.subject}&contact=${formData.contact}&message=${formData.message}`).then(res => {
        console.log(res)
        const { data } = res || {}
        console.log(data)
        if (data.code === 0) {
             ElNotification({
                title: 'Success',
                message: 'Submit successfully',
                type: 'success',
            })
        }
    }).finally(() => {
        loading.value = false
    })
}

onMounted(() => {
    window.addEventListener('scroll', (e) => {
        clientHeight.value = document.documentElement.clientHeight
        scrollHeight.value = document.documentElement.scrollHeight
        scrollTop.value = document.documentElement.scrollTop
        if (clientHeight.value + scrollTop.value >= scrollHeight.value - clientHeight.value) {
            console.log('到底了')
        } else {
            gsap.to('.top', {
                opacity: 1 - (scrollTop.value / videoClientHeight.value),
                y: scrollTop.value / 2
            })
        }
        
    })
    ctx = gsap.context(() => {
        gsap.from('.logo', {
            scrollTrigger: '.logo',
            duration: 2,
            opacity: 0,
            rotationY: 180,
            transformOrigin: "50% 50% 50%",
        })
        gsap.from('.guide__img', {
            scrollTrigger: '.guide__img',
            duration: 2,
            opacity: 0
        })
        var topTl = gsap.timeline();
        topTl.from('.top', {
            opacity: 0.5
        })
        topTl.from('.title', {
            y: 200,
            opacity: 0
        })
        gsap.from('.box1__left', {
            scrollTrigger: '.box1__left',
            xPercent: -100
        })
        gsap.from('.box1__right', {
            scrollTrigger: '.box1__left',
            xPercent: 100
        })
        gsap.from('.box2', {
            scrollTrigger: '.box2',
            scale: 0
        })
         gsap.from('.project-car', {
            scrollTrigger: '.project-car',
            duration: 1,
            rotationY: 180,
            transformOrigin: "50% 50% 50%",
        })
        gsap.to('.box4-box', {
            scrollTrigger: '.box4-box',
            xPercent: -100,
            duration: 60,
            ease: 'none',
            repeat: -1
        })
    }, main.value);
});
onUnmounted(() => {
    ctx.revert();
});
</script>

<template>
    <div class="container" ref="scrollContainer">
        <img class="logo" src="@/assets/image15.png" @load="coverImgload" />
        <div class="top" id="top">
            <video autoplay ref="videoRef" class="cover" loop muted playsline src="@/assets/AMAbanner.mp4"  @loadeddata="onVideoLoaded"></video>
            <!-- <img ref="videoRef" class="topImg cover" src="@/assets/image.png" @load="coverImgload" /> -->
            <img class="title" src="@/assets/image5.png" />
            <img class="guide__img" src="@/assets/image10.png" />
        </div>
        <div class="main" ref="topRef">
            <div class="plbase box1">
                <div class="box1__item box1__left">
                    <div class="text1 mb19">
                        {{ textJSON.box1.title }}
                    </div>
                    <div class="box1__info mb19">
                        {{ textJSON.box1.paragraph1 }}
                    </div>
                    <div class="box1__info">
                        {{ textJSON.box1.paragraph2 }}
                    </div>
                </div>
                <div class="box1__item box1__right">
                    <img class="box1__right__img" src="@/assets/image17.png" />
                </div>
            </div>
            <div class="plbase box2">
                <div class="box2__title">
                    {{ textJSON.box2.title }}
                </div>
                <div class="fr box2__bottom">
                    <div class="fc box2__bottom__item box2__1">
                        <img class="box2__bottom__img" src="@/assets/image14.png" />
                        <div class="box2__bottom__text">
                            {{ textJSON.box2.paragraph1 }}
                        </div>
                    </div>
                    <div class="fc box2__bottom__item box2__2">
                        <img class="box2__bottom__img" src="@/assets/image13.png" />
                        <div class="box2__bottom__text">
                            {{ textJSON.box2.paragraph2 }}
                        </div>
                    </div>
                    <div class="fc box2__bottom__item box2__3">
                        <img class="box2__bottom__img" src="@/assets/image12.png" />
                        <div class="box2__bottom__text">
                            {{ textJSON.box2.paragraph3 }}
                        </div>
                    </div>
                    <div class="fc box2__bottom__item box2__5">
                        <img class="box2__bottom__img" src="@/assets/image11.png" />
                        <div class="box2__bottom__text">
                            {{ textJSON.box2.paragraph4 }}
                        </div>
                    </div>
                </div>
            </div>
             <div class="plbase box3">
                <img class="box3__bg" src="@/assets/image4.png" />
                <div class="fr box3__main">
                    <div class="box3__left">
                        <div class="text1">{{ textJSON.box3.title }}</div>
                        <div class="text2">{{ textJSON.box3.title2 }}</div>
                        <div class="frc box3__project">
                            <div class="box3__project--markers"></div>
                            <div class="box3__project--text">
                                 {{ textJSON.box3.title3 }}
                            </div>
                        </div>
                        <div class="box3__info">
                            {{ textJSON.box3.paragraph4 }}
                        </div>
                        <div class="box3__info">
                            {{ textJSON.box3.paragraph5 }}
                        </div>
                        <div class="box3__button">
                            <DownloadBtn></DownloadBtn>
                        </div>
                    </div>
                    <div class="box3__right">
                        <ProjectCar class="project-car"></ProjectCar>
                    </div>
                </div>
             </div>
             <div class="box4">
                <div class="box4-section">
                    <div class="box4-box">
                        <img class="box4-section__img" src="@/assets/image18.png">
                    </div>
                    <div class="box4-box">
                        <img class="box4-section__img" src="@/assets/image18.png">
                    </div>
                </div>
             </div>
             <div class="plbase box5">
                <img class="box5__bg" src="@/assets/image19.png">
                <div class="text1">
                    {{ textJSON.box5.title }}
                </div>
                <div class="text2">
                    {{ textJSON.box5.title1 }}
                </div>
                <div class="form">
                    <div class="fr form__box">
                         <div class="from__item form__left">
                            <div class="form__input">
                                <div class="form__input__label">Name (compulsory)</div>
                                <input type="text" class="form__input__input" v-model="formData.name">
                            </div>
                            <div class="form__input">
                                <div class="form__input__label">Email (compulsory)</div>
                                <input type="text" class="form__input__input" v-model="formData.email">
                            </div>
                            <div class="form__input">
                                <div class="form__input__label">Contact</div>
                                <input type="text" class="form__input__input" v-model="formData.contact">
                            </div>
                        </div>
                        <div class="from__item form__right">
                            <div class="form__input">
                                <div class="form__input__label">Subject</div>
                                <input type="text" class="form__input__input" v-model="formData.subject">
                            </div>
                            <div class="form__input f1">
                                <div class="form__input__label">Message</div>
                                <textarea v-model="formData.message" class="form__input__input form__input__input--textarea f1" rows="10"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="form__submit">
                        <div class="form__submit__btn" @click="onContactUs">
                            Submit
                        </div>
                    </div>
                </div>
             </div>
             <div class="plbase footer">
                <div class="footer__top">
                    <!-- <div class="footer__top__contact">
                        <Contact></Contact>
                    </div> -->
                    <div class="footer__top__mailAddress">
                        <MailAddress></MailAddress>
                    </div>
                    <div class="footer__top__email">
                        <Email></Email>
                    </div>
                </div>
                <div class="copyright">
                    <div class="copyright__text copyright__text--copyright">
                        {{ textJSON.footer.title }}
                    </div>
                    <div class="copyright__text copyright__text--Disclaimer">
                        {{ textJSON.footer.title1 }}
                    </div>
                </div>
             </div>
        </div>
    </div>
</template>

<style scoped>
.plbase{
    padding-left: 15.78vw;
}
.mb19{
    margin-bottom: 19px;
}
.text1{
    font-weight: 600;
    font-size: 66px;
    color: #F16323;
    line-height: 70px;
}
.text2{
    font-weight: bold;
    font-size: 21px;
    color: #B3B3B3;
    line-height: 33px;
}
.fr{
    display: flex;
    flex-direction: row;
}
.frc{
    display: flex;
    flex-direction: row;
    align-items: center;
}
.fc{
    display: flex;
    flex-direction: column;
}
.f1{
    flex: 1;
}
.top{
    position: relative;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
}
.cover{
    width: 100vw;
    max-width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 50%;
    inset-inline-start: 50%;
    transform: translate(-50%, -50%);
}
.guide__img{
    width: 6.1vw;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
}
.logo{
    width: 10.5vw;
    position: absolute;
    z-index: 2;
    top: 1.8vw;
    left: 2.5vw;
}
.title{
    width: 62.9vw;
}
.main{
    background-color: #fff;
    padding-top: 4.21vw;
    position: relative;
}
.box1{
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 118px;
}
.box1__item{
}
.box1__left{
    width: 41.1vw;
    margin-right: 45px;
}
.box1__right__img{
    width: 22.63vw;
}
.box1__info{
    font-weight: 400;
    font-size: 18px;
    color: #343434;
    line-height: 20px;
    text-align: left;
}
.box2__title{
    font-weight: 600;
    color: #343434;
    font-size: 36px;
    line-height: 33px;
    width: 35.42vw;
    margin-bottom: 48px;
}
.box2__bottom__img{
    width: 7.36vw;
    margin-bottom: 22px;
}
.box2__bottom__item{
    width: 13.15vw;
    margin-right: 4.31vw;
}
.box2__bottom__text{
    font-weight: 400;
    font-size: 18px;
    color: #343434;
    line-height: 20px;
}
.box3{
    padding-top: 160px;
    padding-bottom: 70px;
    position: relative;
}
.box3__main{
    position: relative;
}
.box3__bg{
    position: absolute;
    top: 0;
    height: 100%;
    left: 0;
    width: 100%;
}
.box3__left{
    width: 35.4vw;
}
.box3__project{
    margin-top: 58px;
    margin-bottom: 12px;
}
.box3__project--markers{
    width: 21px;
    height: 21px;
    background-color: #F16323;
    transform: rotate(45deg);
}
.box3__project--text{
    font-weight: bold;
    font-size: 21px;
    color: #343434;
    line-height: 33px;
    margin-left: 6px;
}
.box3__info{
    width: 27.36vw;
    font-weight: 400;
    font-size: 18px;
    color: #343434;
    line-height: 20px;
}
.box3__button{
    width: 23.84vw;
    margin-top: 100px;
}
.box3__right{
    display: flex;
    flex-direction: row;
    align-items: center;
}
.box4{
    position: relative;
    padding: 41px 0 60px;
    width: 100vw;
    overflow: hidden;
}
.box4-box{
    box-sizing: border-box;
    width: 100vw;
    padding: 0 0.6vw;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
}
.box4-section{
    width: 200vw;
    display: flex;
    flex-direction: row;
}
.box4::before{
    z-index: 2;
    display: block;
    content: "";
    position: absolute;
    top: 41px;
    bottom: 60px;
    left: 0;
    width: 27.36vw;
    background: linear-gradient(270deg, rgba(255,255,255,0) 0%, #FFFFFF 70%, #FFFFFF 100%);
}
.box4::after{
    z-index: 2;
    display: block;
    content: "";
    position: absolute;
    top: 41px;
    bottom: 60px;
    right: 0;
    width: 27.36vw;
    background: linear-gradient(-270deg, rgba(255,255,255,0) 0%, #FFFFFF 70%, #FFFFFF 100%);
}
.box4-section__img{
    width: 98.8vw;
}
.box5{
    background-color: #F3F3F3;
    padding-top: 60px;
    padding-bottom: 93px;
    position: relative;
    padding-right: 15.78vw;
}
.box5__bg{
    width: 100%;
    position: absolute;
    top: 25%;
    left: 0;
}
.form{
    margin-top: 50px;
    position: relative;
}
.form__box{
    justify-content: space-between;
}
.from__item{
    display: flex;
    flex-direction: column;
    width: 48%;
}
.form__input{
    margin-bottom: 28px;
}
.form__input__label{
    font-weight: 400;
    font-size: 18px;
    color: #343434;
    line-height: 20px;
    margin-bottom: 5px;
}
.form__input__input{
    width: 100%;
    height: 50px;
    border-radius: 12px;
    border: 1px solid #C8C8C8;
    font-size: 22px;
    padding: 0 8px;
}
.form__input__input--textarea{
    height: 153px;
    resize: none;
    padding: 8px;
}
.form__submit{
    padding-top: 58px;
    display: flex;
    justify-content: center;
}
.form__submit__btn{
    width: 13.47vw;
    height: 50px;
    background-color: #F16323;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 20px;
}
.footer{
    padding-top: 34px;
    padding-bottom: 13px;
    background-color: #2A2A2A;
}
.footer__top{
    display: flex;
    flex-direction: row;
}
.footer__top__contact{
    width: 16vw;
}
.footer__top__mailAddress{
    width: 21.47vw;
    margin-right: 55px;
}
.copyright{
    margin-top: 54px;
}
.copyright__text{
    font-weight: 500;
    font-size: 12px;
    color: #838383;
    line-height: 16px;
    display: inline-block;
}
.copyright__text--copyright{
    margin-right: 8.3vw;
}
</style>
